﻿import * as metastoreApi from "../../shared/metastore-api-client";
import { ClientAppSettings } from "../../shared/providers/SettingsProvider";

export interface BreadcrumbItem {
    id?: string;
    title?: string;
    url?: string;
    children?: BreadcrumbItem[];
}

export type ErrorType = "NotFound" | "Connectivity" | "Maintenance" | "Generic";

export interface AppError {
    type: ErrorType;
    message: string;
    details: string; // Markdown containing message details...
}

export interface AppErrors {
    global?: AppError; // Fatal error during app load - don't attempt to render anything other than the error page...
    page?: AppError; // Page-specific error - render the error page in the main content area...
}

export interface AppUser {
    name: string;
    roles: string[];
    effectiveTags: string[];
    isDeveloper: boolean;
}

export interface Banner {
    severity: "error" | "warning" | "info" | "success";
    content: string;
}

export interface AppState {
    loading: boolean;
    activeBranch: string;
    menuItems: metastoreApi.MenuItemModel[] | "loading";
    menuIsExpanded: boolean;
    breadcrumbStack: BreadcrumbItem[];
    errors: AppErrors;
    user: AppUser;
    settings: ClientAppSettings;
    banner?: Banner;
}

export const LOAD_APP = "LOAD_APP";
export const SHOW_APP = "SHOW_APP";
export const TOGGLE_MENU = "TOGGLE_MENU";
export const SET_MENU_IS_EXPANDED = "SET_MENU_IS_EXPANDED";
export const SET_BREADCRUMB_STACK = "SET_BREADCRUMB_STACK";
export const SET_GLOBAL_ERROR = "SET_GLOBAL_ERROR";
export const SET_PAGE_ERROR = "SET_PAGE_ERROR";
export const SET_MENU_ITEMS = "SET_MENU_ITEMS";
export const SHOW_BANNER = "SHOW_BANNER";
export const DISMISS_BANNER = "DISMISS_BANNER";

interface LoadAppAction {
    type: typeof LOAD_APP;
    user: AppUser;
    settings: ClientAppSettings;
}

interface ShowAppAction {
    type: typeof SHOW_APP;
    activeBranch: string;
    settings: ClientAppSettings;
    menuItems?: metastoreApi.MenuItemModel[];
}

interface ToggleMenuAction {
    type: typeof TOGGLE_MENU;
}

interface SetBreadcrumbStackAction {
    type: typeof SET_BREADCRUMB_STACK;
    breadcrumbStack: BreadcrumbItem[];
}

interface SetMenuIsExpandedAction {
    type: typeof SET_MENU_IS_EXPANDED;
    value: boolean;
}

interface SetGlobalErrorAction {
    type: typeof SET_GLOBAL_ERROR;
    error: AppError;
}

interface SetPageErrorAction {
    type: typeof SET_PAGE_ERROR;
    error: AppError;
}

interface SetMenuItemsAction {
    type: typeof SET_MENU_ITEMS;
    menuItems: metastoreApi.MenuItemModel[];
}

interface ShowBannerAction {
    type: typeof SHOW_BANNER;
    banner: Banner;
}

interface DismissBannerAction {
    type: typeof DISMISS_BANNER;
}

export type AppActionTypes = LoadAppAction | ShowAppAction | ToggleMenuAction | SetBreadcrumbStackAction | SetMenuIsExpandedAction | SetGlobalErrorAction | SetPageErrorAction | SetMenuItemsAction | ShowBannerAction | DismissBannerAction;